import styled from '@emotion/styled';
import { colorPalettes, Flex } from '@linearb/linui-common';

const HalfCircle = styled.div`
  border-radius: 35%;
  border: 2px solid
    ${({ theme }) =>
      colorPalettes[theme.palette.mode].background.backgroundElements};
`;

const CircleContainer = styled(Flex)`
  fles-direction: column;
  height: 40rem;
  width: 10rem;
  flex-direction: column;
  justify-content: space-between;

  ${HalfCircle} {
    width: 10rem;
    height: 11rem;
    top: 253px;
  }
`;

const CircleFlexContainer = styled(Flex)`
  height: 100%;
  width: 10rem;
  flex-direction: column;
  justify-content: center;
  ${CircleContainer} {
    width: 10rem;
    margin-left: 2.5rem;
  }
`;

const Circles = () => {
  return (
    <CircleFlexContainer>
      <CircleContainer>
        <HalfCircle />
        <HalfCircle />
      </CircleContainer>
    </CircleFlexContainer>
  );
};
export default styled(Circles)``;
